<template>
  <v-dialog v-model="dialog" persistent scrollable="" max-width="1300">
    <v-card width="100%">
      <v-card-title class="pa-5 bg-D5EEED">
        <v-btn :x-small="almost_mobile" icon disabled
          ><v-icon>mdi-clear</v-icon></v-btn
        >
        <span class="font-24" style="color: #4ba69d; font-weight: bold"
          >ข้อมูลพนักงาน</span
        >
        <v-spacer></v-spacer>
        <v-btn icon color="#4BA69D" @click="closePage()" small
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-row class="bg-D5EEED">
              <v-col
                :style="
                  almost_mobile ? 'margin-left: 32px;' : 'margin-left: 64px;'
                "
              >
                <v-row>
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <span class="custom-text">รหัสพนักงาน : </span>
                    <span class="custom-text ml-2">
                      {{
                        item_original.employee_id
                          ? item_original.employee_id
                          : "-"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <span class="custom-text">แผนก : </span>
                    <span class="custom-text ml-2">
                      {{
                        item_original.department
                          ? item_original.department
                          : "-"
                      }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <span class="custom-text">ชื่อ-สกุล : </span>
                    <span class="custom-text ml-2">
                      {{ item_original.account_title_th || "" }}
                      {{ item_original.first_name_th || "" }}
                      {{ item_original.last_name_th || "" }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <span class="custom-text">หมายเลขโทรศัพท์ : </span>
                    <span class="custom-text ml-2">
                      {{ item_original.mobile }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4" lg="4">
                    <span class="custom-text">เพศ : </span>
                    <span class="custom-text ml-2">
                      {{ genderPerson(item_original.account_title_th) }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="4">
                    <span class="custom-text">วัน/เดือน/ปีเกิด : </span>
                    <span class="custom-text ml-2">
                      {{ formatDate(item_original.birth_date) || "-" }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" lg="2">
                    <span class="custom-text">อายุ : </span>
                    <span class="custom-text ml-2">
                      {{
                        ageCalcilar(item_original.birth_date, item_original.age)
                      }}
                    </span>
                    <span class="custom-text ml-2">ปี</span>
                  </v-col>
                  <v-col cols="12" sm="12" md="2" lg="2" class="pt-2 px-5">
                    <div v-if="view == true" class="bottomright">
                      <v-btn
                        color="#00a99d"
                        outlined
                        dark
                        @click="view = false"
                        small
                        class="card-search"
                        width="120"
                      >
                        <v-icon>mdi-file-edit</v-icon> แก้ไขข้อมูล
                      </v-btn>
                    </div>
                    <div v-else class="bottomright">
                      <v-chip
                        style="min-width: 120px; justify-content: center"
                        class="card-search"
                        color="orange"
                        outlined
                      >
                        เปิดแก้ไข
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-top: 36px">
            <v-stepper non-linear v-model="e1">
              <v-stepper-header>
                <v-divider></v-divider>
                <v-stepper-step editable step="1" color="#00a99d">
                  <span class="w-500 font-16">ข้อมูลส่วนตัว</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step editable step="2" color="#00a99d">
                  <span class="w-500 font-16"
                    >ข้อมูลที่อยู่ตามทะเบียนราษฎร์</span
                  >
                </v-stepper-step>

                <v-divider></v-divider>

                <!-- <v-stepper-step step="3" editable color="#00a99d">
                  <span class="w-500 font-16">ข้อมูลที่อยู่สำหรับจัดส่ง</span>
                </v-stepper-step> -->
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form ref="data_info" class="px-3">
                    <v-row class="pt-5">
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <div class="d-flex flex-column">
                          <span> เพศ<span class="red--text">*</span> </span>
                          <v-radio-group
                            v-model="items.gender"
                            row
                            dense
                            class="pa-0 pt-2 ma-0"
                            @change="genderChange"
                            :rules="rules.gender"
                            required
                            :readonly="view"
                            hide-details="auto"
                          >
                            <v-radio
                              label="ชาย"
                              value="ชาย"
                              color="#00a99d"
                            ></v-radio>
                            <v-radio
                              label="หญิง"
                              value="หญิง"
                              color="#00a99d"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <div class="d-flex flex-column">
                          <span>
                            คำนำหน้า<span class="red--text">*</span>
                          </span>
                          <v-select
                            solo
                            placeholder="เลือกคำนำหน้าชื่อ"
                            @input="titleChange"
                            v-model="items.account_title_th"
                            :items="titleItems"
                            hide-details="auto"
                            dense
                            :rules="rules.account_title_th"
                            required
                            :readonly="view"
                            item-color="teal darken-2"
                            color="#00a99d"
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0">
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span>
                            ชื่อ (ภาษาไทย)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            placeholder="ชื่อ (ภาษาไทย)"
                            hide-details="auto"
                            dense
                            :readonly="view"
                            :rules="rules.first_name_th"
                            required
                            v-model="items.first_name_th"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span>
                            นามสกุล (ภาษาไทย)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            placeholder="นามสกุล (ภาษาไทย)"
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.last_name_th"
                            :rules="rules.last_name_th"
                            required
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span> ชื่อ (ภาษาอังกฤษ) </span>
                          <v-text-field
                            solo
                            placeholder="ชื่อ (ภาษาอังกฤษ)"
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.first_name_eng"
                            required
                          ></v-text-field>
                        </div>
                        <!-- <span class="red--text">*</span> -->
                        <!-- :rules="rules.first_name_eng" -->
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span> นามสกุล (ภาษาอังกฤษ) </span>
                          <!-- <span class="red--text">*</span> -->
                          <v-text-field
                            solo
                            placeholder="นามสกุล (ภาษาอังกฤษ)"
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.last_name_eng"
                            required
                          ></v-text-field>
                        </div>
                        <!-- :rules="rules.last_name_eng" -->
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        class="px-3 d-flex flex-column"
                      >
                        <div>
                          <span> ประเภทบัตร </span>
                          <span>
                            {{ displayIdCard(items.id_card_type)
                            }}<span class="red--text">*</span>
                          </span>
                        </div>
                        <div class="d-flex">
                          <v-select
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.id_card_type"
                            item-text="text"
                            item-value="value"
                            :items="itemType"
                            style="width: 40%"
                            disabled
                          ></v-select>
                          <v-text-field
                            solo
                            placeholder="หมายเลขบัตรประชาชน"
                            hide-details="auto"
                            dense
                            :value="
                              role_name == 'เจ้าหน้าที่เวชระเบียน'
                                ? items.id_card_num
                                : displayCID(items.id_card_num)
                            "
                            style="width: 60%"
                            disabled
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <div class="d-flex flex-column">
                          <span> วัน / เดือน / ปีเกิด </span>
                          <v-menu
                            ref="birth_date_menu"
                            v-model="menubirth_date"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            color="#00a99d"
                            :disabled="view"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                placeholder="วัน / เดือน / ปีเกิด"
                                dense
                                v-model="formatBirthDate"
                                append-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                color="#00a99d"
                                hide-details="auto"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="items.birth_date"
                              no-title
                              scrollable
                              :max="yearmax"
                              locale="th"
                              color="#00a99d"
                              @click="calculateAge_menu(items.birth_date)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="#5F676B"
                                @click="cancel_birth()"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="#00a99d"
                                @click="calculateAge_menu(items.birth_date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </div>
                        <!-- <span class="red--text">*</span> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <div class="d-flex flex-column">
                          <span> อายุ</span>
                          <v-text-field
                            solo
                            placeholder="อายุ"
                            hide-details="auto"
                            v-model="items.age"
                            dense
                            :value="calculateAge(items.birth_date)"
                            required
                            :readonly="view"
                          ></v-text-field>
                        </div>
                        <!-- <span class="red--text">*</span>
                        :rules="rules.age" -->
                      </v-col>
                      <v-col cols="12" sm="6" md="2" lg="2">
                        <div class="d-flex flex-column">
                          <span> หมู่เลือด </span>
                          <v-select
                            solo
                            placeholder="หมู่เลือด"
                            :items="['A', 'B', 'O', 'AB']"
                            v-model="items.blood"
                            hide-details="auto"
                            dense
                            :readonly="view"
                            color="#00a99d"
                            item-color="teal darken-2"
                          ></v-select>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            หมายเลขโทรศัพท์<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            placeholder="หมายเลขโทรศัพท์"
                            hide-details="auto"
                            dense
                            v-model="items.mobile"
                            :readonly="view"
                            :rules="rules.mobile"
                            required
                            disabled
                            class="disable-textfield"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span>
                            Email (Email one)<span
                              class="red--text"
                              v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            placeholder="Email (Email one)"
                            hide-details="auto"
                            dense
                            disabled
                            v-model="items.email"
                            :readonly="view"
                            class="disable-textfield"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" lg="6" class="pb-6">
                        <div class="d-flex flex-column">
                          <span> HN </span>
                          <v-text-field
                            solo
                            placeholder="HN"
                            hide-details="auto"
                            dense
                            v-model="items.HN"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <div class="d-flex align-center">
                          <span class="pr-5 text-007C92 w-500 font-18"
                            >ข้อมูลสถานประกอบการ</span
                          >
                          <v-divider color="#007C92 "></v-divider>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="py-5">
                      <v-col cols="12" sm="6" md="4" xl="4" lg="4" class="pt-0">
                        <div class="d-flex flex-column">
                          <span> สถานประกอบการ</span>
                          <v-text-field
                            placeholder="ชื่อสถานประกอบการ"
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.company"
                            :readonly="view"
                            required
                          ></v-text-field>
                        </div>
                        <!-- <div class="px-3"></div> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="4" lg="4" class="pt-0">
                        <div class="d-flex flex-column">
                          <span> รหัสพนักงาน </span>
                          <v-text-field
                            placeholder="รหัสพนักงาน"
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.employee_id"
                            :readonly="view"
                            required
                          ></v-text-field>
                        </div>
                        <!-- <span class="red--text">*</span> -->
                        <!-- :rules="rules.employee_id" -->
                        <!-- <div class="px-3"></div> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="4" lg="4" class="pt-0">
                        <div class="d-flex flex-column">
                          <span> ตำแหน่ง </span>
                          <v-text-field
                            placeholder="ตำแหน่ง"
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.position"
                            :readonly="view"
                            required
                          ></v-text-field>
                        </div>
                        <!-- <div class="px-3"></div> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="4" lg="4" class="pt-0">
                        <div class="d-flex flex-column">
                          <span> แผนก </span>
                          <v-text-field
                            placeholder="แผนก"
                            solo
                            hide-details="auto"
                            v-model="items.department"
                            dense
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <div class="d-flex align-center">
                          <span class="pr-5 text-007C92 w-500 font-18"
                            >ข้อมูลโรคประจำตัว</span
                          >
                          <v-divider color="#007C92 "></v-divider>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="py-5">
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            โรคประจำตัว<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            placeholder="โรคประจำตัว"
                            hide-details="true"
                            dense
                            v-model="items.congenitalDisease"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            แพ้ยา (ชื่อยา)<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            placeholder="แพ้ยา (ชื่อยา)"
                            hide-details="true"
                            dense
                            v-model="items.allergyDrug"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> อาการแพ้ยา </span>
                          <v-text-field
                            solo
                            placeholder="อาการแพ้ยา"
                            hide-details="true"
                            dense
                            v-model="items.allergyDrugDetail"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-form ref="add_info" class="px-3">
                    <v-row class="py-5">
                      <v-col cols="12" sm="6" md="2" lg="2">
                        <div class="d-flex flex-column">
                          <span>
                            บ้านเลขที่<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            placeholder="บ้านเลขที่"
                            hide-details="auto"
                            dense
                            v-model="items.address.house_no"
                            :disabled="view"
                            :rules="rules.house_no"
                            required
                          ></v-text-field>
                        </div>
                        <!-- :rules="rules.house_no"
                            required -->
                        <!-- <div class="px-3"></div> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="2" lg="2">
                        <div class="d-flex flex-column">
                          <span> หมู่ </span>
                          <v-text-field
                            solo
                            placeholder="หมู่"
                            hide-details="auto"
                            v-model="items.address.moo_no"
                            dense
                            :disabled="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> ถนน / ซอย </span>
                          <v-text-field
                            solo
                            placeholder="ถนน / ซอย"
                            hide-details="auto"
                            dense
                            v-model="items.address.soi"
                            :disabled="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            จังหวัด<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-autocomplete
                            :items="set_province"
                            item-value="province"
                            item-text="province"
                            @input="getAmphoe('template')"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกจังหวัด"
                            v-model="items.address.province"
                            item-color="teal darken-2"
                            color="#00a99d"
                            :disabled="view"
                            :rules="rules.province"
                            required
                          >
                            <template slot="no-data">
                              <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            อำเภอ / เขต<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-autocomplete
                            :items="set_amphoe"
                            item-value="amphoe"
                            item-text="amphoe"
                            @input="getTambon('template')"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกอำเภอ/เขต"
                            v-model="items.address.amphur"
                            item-color="teal darken-2"
                            color="#00a99d"
                            :disabled="view"
                            :rules="rules.amphur"
                            required
                          >
                            <template slot="no-data">
                              <span class="pl-2">กรุณาเลือกจังหวัด</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            ตำบล / แขวง<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-autocomplete
                            :items="set_tambon"
                            item-value="tambon"
                            item-text="tambon"
                            @input="getPostal($event), showAddress()"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกตำบล/แขวง"
                            v-model="items.address.tambon"
                            item-color="teal darken-2"
                            color="#00a99d"
                            :disabled="view"
                            :rules="rules.tambon"
                            required
                          >
                            <template slot="no-data">
                              <span class="pl-2">กรุณาเลือกอำเภอ</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            รหัสไปรษณีย์<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            placeholder="รหัสไปรษณีย์"
                            hide-details="auto"
                            v-model="items.address.zipcode"
                            dense
                            :disabled="view"
                            :rules="rules.zipcode"
                            required
                            @input="showAddress()"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div class="d-flex flex-column">
                          <span> จุดสังเกตเพิ่มเติม </span>
                          <v-textarea
                            v-model="items.address.landmark"
                            placeholder="จุดสังเกตเพิ่มเติม"
                            solo
                            hide-details="auto"
                            dense
                            auto-grow
                            :disabled="view"
                            rows="3"
                          ></v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="my-0">
                      <v-col
                        cols="12"
                        lg="4"
                        md="4"
                        sm="4"
                        align-self="start"
                        class="mt-6"
                      >
                        <v-btn
                          v-if="view == false"
                          depressed
                          color="#F7F8FA"
                          @click="find_locate_user()"
                          block
                          style="white-space: normal; display: inline"
                        >
                          <v-icon size="20" class="pr-1" color="#00A99D"
                            >mdi-crosshairs-gps</v-icon
                          ><span class="text-7E8386 w-400 font-14"
                            >คลิกเพื่อหาที่อยู่ปัจจุบันของคุณ</span
                          >
                        </v-btn>
                        <v-card v-else color="#F7F8FA" elevation="0">
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="12"
                                align-self="center"
                                class="pa-1"
                                align="center"
                              >
                                <v-icon
                                  size="20"
                                  class="pr-1 pb-1"
                                  color="#00A99D"
                                  >mdi-map-marker-radius-outline</v-icon
                                >
                                <span class="text-7E8386 w-400 font-14"
                                  >ที่อยู่ปัจจุบันของคุณ</span
                                >
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" lg="4" md="4" sm="4">
                        <div class="d-flex flex-column">
                          <span>
                            ละติจูด<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            v-model="items.address.lat"
                            placeholder="ละติจูด"
                            solo
                            hide-details="auto"
                            dense
                            :disabled="view == true"
                            :rules="rules.lat"
                            required
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" lg="4" md="4" sm="4">
                        <div class="d-flex flex-column">
                          <span>
                            ลองติจูด<span class="red--text" v-show="!view"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            v-model="items.address.lng"
                            placeholder="ลองติจูด"
                            solo
                            hide-details="auto"
                            dense
                            :disabled="view == true"
                            :rules="rules.lng"
                            required
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" v-show="view == false">
                        <v-text-field
                          solo
                          dense
                          placeholder="ค้นหาตำแหน่งที่อยู่"
                          v-model="items.location_address"
                          hide-details="auto"
                          @keypress.enter="getLocation(items.location_address)"
                          color="#00A99D"
                          hint="กรอกคำค้นหา กด Enter หรือ กดปุ่มค้นหา เพื่อค้นหาที่อยู่ของท่าน"
                        >
                          <template slot="append">
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  color="#00A99D"
                                  @click="getLocation(items.location_address)"
                                >
                                  <v-icon medium dark>mdi-magnify</v-icon>
                                </v-btn>
                              </template>
                              <span>ค้นหา</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                        <!-- <div class="d-flex flex-column">
                      <span> ตำแหน่ง </span>
                      <GmapAutocomplete
                        @place_changed="setPlace"
                        class="pl-2 gmap-auto"
                        :options="{
                          fields: [
                            'geometry',
                            'formatted_address',
                            'address_components',
                          ],
                        }"
                      />
                      :value="search"
                    </div> -->
                      </v-col>
                      <v-col cols="12" v-if="view == false">
                        <StadiaMap
                          ref="locateUser"
                          :items="items.address"
                          @place-name="changeLocation"
                          @map-clicked="changeLocation"
                        />
                      </v-col>
                      <v-col cols="12" v-else-if="view == true">
                        <ViewMap
                          :lat="items.address.lat"
                          :lng="items.address.lng"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <!-- <v-stepper-content step="3">
                  <v-row>
                    <v-col cols="12">
                      <DeliveryAddress
                        :one_id="one_id"
                        :cid="cid"
                        :address_data="address_data"
                        @close="closePage"
                        :step_page="e1"
                        :type="view"
                      />
                    </v-col>
                  </v-row>
                </v-stepper-content> -->
              </v-stepper-items>
            </v-stepper>
          </v-col>
        </v-row>

        <v-card-actions class="justify-center">
          <v-col cols="4" class="pl-2 pr-0"
            ><v-btn
              v-if="this.e1 == '1' && view == false"
              @click="ConfirmedData()"
              block
              dark
              depressed
              color="#00a99d"
              :loading="btn_loading"
              type="submit"
              style="border-radius: 20px 5px"
              >บันทึกข้อมูลส่วนตัว</v-btn
            >
            <v-btn
              v-else-if="this.e1 == '2' && view == false"
              @click="ConfirmedAddress(items)"
              block
              dark
              depressed
              color="#00a99d"
              :loading="btn_loading"
              type="submit"
              style="border-radius: 20px 5px"
              >บันทึกที่อยู่ทะเบียนราษฎร์</v-btn
            ></v-col
          >
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import StadiaMap from "@/components/stadiamap/StadiaMap.vue";
// import { mapMutations, mapGetters } from "vuex";
import functioncryto from "@/services/encrypt.js";
// import DeliveryAddress from "@/components/DeliveryAddress.vue";
import ViewMap from "./ViewMap.vue";
export default {
  components: {
    // DeliveryAddress,
    ViewMap,
    StadiaMap,
  },
  data: () => ({
    role_name: sessionStorage.role_name,
    atitude: 0,
    longitude: 0,
    latitude: 0,
    lat: 0,
    lng: 0,
    step: 1,
    e1: 1,
    set_province: [],
    set_amphoe: [],
    set_tambon: [],
    dialog: false,
    view: true,
    isEmpty: [(v) => !!v || "กรุณากรอกข้อมูล"],
    isEmptySelect: [(v) => !!v || "กรุณาเลือกข้อมูล"],
    btn_loading: false,
    item_original: {
      age: "",
      mobile: "",
      id_card_type: "ID_CARD",
      id_card_num: "",
      address: {
        house_no: "",
        moo_no: "",
        soi: "",
        province: "",
        amphur: "",
        tambon: "",
        zipcode: "",
        lat: "",
        lng: "",
      },
      email: "",
      account_title_th: "",
      account_title_eng: "",
      first_name_eng: "",
      first_name_th: "",
      last_name_eng: "",
      last_name_th: "",
      birth_date: "",
      gender: "",
      blood: "",
      HN: "",
      hos_code: "",
      congenitalDisease: "",
      allergyDrug: "",
      allergyDrugDetail: "",
      latitude: "",
      longitude: "",
      // biz_id: "",
      search: null,
    },
    items: {},
    // {
    //   age: "",
    //   mobile: "",
    //   id_card_type: "ID_CARD",
    //   id_card_num: "",
    //   address: {
    //     house_no: "",
    //     moo_no: "",
    //     soi: "",
    //     province: "",
    //     amphur: "",
    //     tambon: "",
    //     zipcode: "",
    //     lat: "",
    //     lng: "",
    //   },
    //   email: "",
    //   account_title_th: "",
    //   account_title_eng: "",
    //   first_name_eng: "",
    //   first_name_th: "",
    //   last_name_eng: "",
    //   last_name_th: "",
    //   birth_date: "",
    //   gender: "",
    //   blood: "",
    //   HN: "",
    //   hos_code: "",
    //   congenitalDisease: "",
    //   allergyDrug: "",
    //   allergyDrugDetail: "",
    //   latitude: "",
    //   longitude: "",
    //   // biz_id: "",
    //   search: null,
    //   location_address: "",
    //   company: "",
    //   department: "",
    //   employee_id: "",
    //   position: "",
    // },
    titleItems: ["เด็กหญิง", "เด็กชาย", "นางสาว", "นาย", "นาง"],
    itemType: [
      { value: "ID_CARD", text: "บัตรประชาชน" },
      { value: "PASSPORT", text: "PASSPORT" },
    ],
    menubirth_date: false,
    yearmax: "",
    rules: {
      gender: [(v) => !!v || "กรุณาระบุเพศ"],
      account_title_th: [(v) => !!v || "กรุณากรอกเลือกคำนำหน้า"],
      first_name_th: [(v) => !!v || "กรุณากรอก ชื่อ (ภาษาไทย)"],
      last_name_th: [(v) => !!v || "กรุณากรอก นามสกุล (ภาษาไทย)"],
      first_name_eng: [(v) => !!v || "กรุณากรอก ชื่อ (ภาษาอังกฤษ)"],
      last_name_eng: [(v) => !!v || "กรุณากรอก นามสกุล (ภาษาอังกฤษ)"],
      mobile: [
        (v) => !!v || "กรุณากรอกเบอร์โทรศัพท์",
        (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
      ],
      age: [(v) => !!v || "กรุณากรอกอายุ"],
      house_no: [(v) => !!v || "กรุณากรอก บ้านเลขที่"],
      province: [(v) => !!v || "กรุณากรอก จังหวัด"],
      amphur: [(v) => !!v || "กรุณากรอก อำเถอ / เขต"],
      tambon: [(v) => !!v || "กรุณากรอก ตำบล / แขวง"],
      zipcode: [(v) => !!v || "กรุณากรอกรหัสไปรษณีย์"],
      lat: [(v) => !!v || "กรุณากรอกละติจูด"],
      lng: [(v) => !!v || "กรุณากรอกลองติจูด"],
      employee_id: [(v) => !!v || "กรุณากรอกรหัสพนักงาน"],
    },
    one_id: "",
    cid: "",
    address_data: "",
  }),
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
  },
  async created() {
    var now_date = new Date();
    this.yearmax = now_date.getFullYear() - 7 + "-" + 12 + "-" + 31;
    this.items = this.getDefaultItems();
  },
  computed: {
    formatBirthDate() {
      if (this.items.birth_date != "" && this.items.birth_date != null) {
        var year1 = "";
        var year2 = "";
        year1 = moment(this.items.birth_date).locale("th").format("YYYY");
        year2 = (parseInt(year1) + 543).toString();
        return moment(this.items.birth_date)
          .locale("th")
          .format("DD/MM/" + year2);
      } else {
        return "";
      }
    },
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getDefaultItems() {
      return {
        age: "",
        mobile: "",
        id_card_type: "ID_CARD",
        id_card_num: "",
        address: {
          house_no: "",
          moo_no: "",
          soi: "",
          province: "",
          amphur: "",
          tambon: "",
          zipcode: "",
          lat: "",
          lng: "",
        },
        email: "",
        account_title_th: "",
        account_title_eng: "",
        first_name_eng: "",
        first_name_th: "",
        last_name_eng: "",
        last_name_th: "",
        birth_date: "",
        gender: "",
        blood: "",
        HN: "",
        hos_code: "",
        congenitalDisease: "",
        allergyDrug: "",
        allergyDrugDetail: "",
        latitude: "",
        longitude: "",
        // biz_id: "",
        search: null,
        location_address: "",
        company: "",
        department: "",
        employee_id: "",
        position: "",
      };
    },
    find_locate_user() {
      this.$refs.locateUser.getCurrentLocation();
    },
    changeLocation(e) {
      // console.log("🚀 ~ changeLocation ~ e:", e)
      this.items.address.lat = e.lat;
      this.items.address.lng = e.lng;
      this.lat = e.lat;
      this.lng = e.lng;
    },
    async openDialog(item, view = true) {
      console.log("item", item);

      if (item) {
        this.view = view;
        this.e1 = 1;
        this.address_data = item.address ? item.address : [];
        this.one_id = item.one_id;
        this.cid = item.cid;
        this.item_original = {
          account_title_th: JSON.parse(JSON.stringify(item.account_title_th)),
          first_name_th: JSON.parse(JSON.stringify(item.first_name_th)),
          last_name_th: JSON.parse(JSON.stringify(item.last_name_th)),
          birth_date: JSON.parse(JSON.stringify(item.birth_date)),
          mobile: JSON.parse(JSON.stringify(item.mobile)),
          blood: item.blood ? JSON.parse(JSON.stringify(item.blood)) : "",
          HN: item.HN ? JSON.parse(JSON.stringify(item.HN)) : "",
          id_card_num: JSON.parse(
            JSON.stringify(functioncryto.decrypt(item.cid))
          ),
          // id_card_num: item.cid,
          email: item.email ? JSON.parse(JSON.stringify(item.email)) : "",
          employee_id: item.employee_id
            ? JSON.parse(JSON.stringify(item.employee_id))
            : "",
          position: item.position
            ? JSON.parse(JSON.stringify(item.position))
            : "",
          company: item.company ? JSON.parse(JSON.stringify(item.company)) : "",
          department: item.department
            ? JSON.parse(JSON.stringify(item.department))
            : "",
          age: item.age ? item.age : "",
          id_card_type: item.id_card_type,
        };

        if (item.age == undefined || item.age == "") {
          this.calculateAge_title(
            JSON.parse(JSON.stringify(this.item_original.birth_date))
          );
        }
        if (
          item.account_title_th == "เด็กชาย" ||
          item.account_title_th == "นาย"
        ) {
          this.item_original.gender = "ชาย";
        } else if (
          item.account_title_th == "เด็กหญิง" ||
          item.account_title_th == "นาง" ||
          item.account_title_th == "นางสาว"
        ) {
          this.item_original.gender = "หญิง";
        }
        if (item.address !== undefined) {
          var address = item.address.find((ele) => {
            return ele.official == true;
          });
          if (address !== undefined) {
            this.items = {
              age: item.age,
              mobile: item.mobile,
              id_card_type: item.id_card_type || "ID_CARD",
              id_card_num: functioncryto.decrypt(item.cid),
              address: {
                house_no: address.houseNo,
                moo_no: address.moo,
                soi: address.soi,
                province: address.province,
                amphur: address.amphur,
                tambon: address.tambon,
                zipcode: address.zipcode,
                landmark: address.landmark || "",
                lat: address.lat || "",
                lng: address.lng || "",
                default: address.default,
                id: address.id,
              },
              email: item.email || "",
              account_title_th: item.account_title_th,
              account_title_eng: item.account_title_eng,
              first_name_eng: item.first_name_eng,
              first_name_th: item.first_name_th,
              last_name_eng: item.last_name_eng,
              last_name_th: item.last_name_th,
              birth_date: JSON.parse(JSON.stringify(item.birth_date)),
              gender: item.gender,
              blood: item.blood,
              HN: item.HN,
              hos_code: item.hos_code,
              congenitalDisease: item.congenitalDisease,
              allergyDrug: item.allergyDrug,
              allergyDrugDetail: item.allergyDrugDetail,
              latitude: address.latitude,
              longitude: address.longitude,
              _id: item._id,
              one_id: item.one_id,
              cid: item.cid,
              biz_id: item.biz_id,
              employee_id: item.employee_id,
              department: item.department,
              company: item.company,
              position: item.position,
            };
          } else {
            this.items = {
              age: item.age,
              mobile: item.mobile,
              id_card_type: "ID_CARD",
              id_card_num: functioncryto.decrypt(item.cid),
              address: {
                house_no: item.address.houseNo || "",
                moo_no: item.address.moo || "",
                soi: item.address.soi || "",
                province: item.address.province || "",
                amphur: item.address.amphur || "",
                tambon: item.address.tambon || "",
                zipcode: item.address.zipcode || "",
                landmark: item.address.landmark || "",
                lat: "",
                lng: "",
                default: item.address.default,
                id: item.address.id,
              },
              email: item.email || "",
              account_title_th: item.account_title_th,
              account_title_eng: item.account_title_eng,
              first_name_eng: item.first_name_eng,
              first_name_th: item.first_name_th,
              last_name_eng: item.last_name_eng,
              last_name_th: item.last_name_th,
              birth_date: JSON.parse(JSON.stringify(item.birth_date)),
              gender: item.gender,
              blood: item.blood,
              HN: item.HN || "",
              hos_code: item.hos_code,
              congenitalDisease: item.congenitalDisease,
              allergyDrug: item.allergyDrug,
              allergyDrugDetail: item.allergyDrugDetail,
              latitude: "",
              longitude: "",
              _id: item._id,
              one_id: item.one_id,
              cid: item.cid,
              biz_id: item.biz_id,
              employee_id: item.employee_id,
              department: item.department,
              company: item.company,
              position: item.position,
            };
          }
        } else {
          this.items = {
            age: item.age,
            mobile: item.mobile,
            id_card_type: "ID_CARD",
            id_card_num: functioncryto.decrypt(item.cid),
            address: {
              house_no: "",
              moo_no: "",
              soi: "",
              province: "",
              amphur: "",
              tambon: "",
              zipcode: "",
              landmark: "",
              lat: "",
              lng: "",
              default: "",
              id: "",
            },
            email: item.email || "",
            account_title_th: item.account_title_th,
            account_title_eng: item.account_title_eng,
            first_name_eng: item.first_name_eng,
            first_name_th: item.first_name_th,
            last_name_eng: item.last_name_eng,
            last_name_th: item.last_name_th,
            birth_date: JSON.parse(JSON.stringify(item.birth_date)),
            gender: item.gender || "",
            blood: item.blood || "",
            HN: item.HN || "",
            hos_code: item.hos_code || "",
            congenitalDisease: item.congenitalDisease || "",
            allergyDrug: item.allergyDrug || "",
            allergyDrugDetail: item.allergyDrugDetail || "",
            latitude: "",
            longitude: "",
            _id: item._id,
            one_id: item.one_id,
            // cid: item.cid,
            cid: JSON.parse(JSON.stringify(functioncryto.decrypt(item.cid))),
            biz_id: item.biz_id,
            employee_id: item.employee_id || "",
            department: item.department || "",
            company: item.company || "",
            position: item.position || "",
          };
        }
        (this.panel = [0, 1, 2, 3]), (this.dialog = true);
        this.checkGPS();
        this.genderChange();
        this.titleChange();
        await this.getProvince();

        if (this.items.address.province != "") {
          this.getAmphoe("api");
        }

        this.items.location_address = "";
        // this.search = null;
        console.log("item", this.items);
      }
      // console.log("item88888", item);
    },
    closePage() {
      this.$emit("close");
      this.dialog = false;
      this.$refs.data_info.resetValidation();
      this.$refs.add_info.resetValidation();
      this.items = this.getDefaultItems();
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    showBirthDate() {
      var year1 = "";
      var year2 = "";
      // if (this.items.birth_date === undefined || this.items.birth_date === "")
      //   return "";
      year1 = moment(this.item_original.birth_date).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      return moment(this.item_original.birth_date)
        .locale("th")
        .format("DD/MM/" + year2);
    },
    changeLocation3(e) {
      // console.log("9999999", e.latLng.lat());
      // console.log("9999999", e.latLng.lng());
      this.items.address.lat = e.latLng.lat();
      this.items.address.lng = e.latLng.lng();
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
    },
    getGPS() {
      this.latitude = parseFloat(this.items.address.lat || 0);
      this.longitude = parseFloat(this.items.address.lng || 0);
      this.lat = parseFloat(this.items.address.lat || 0);
      this.lng = parseFloat(this.items.address.lng || 0);
    },
    addArea() {
      this.check = true;
    },
    showAddress() {
      var text_address = "";
      // if (
      //   this.items.address.house_no !== "" &&
      //   this.items.address.house_no !== undefined
      // ) {
      //   text_address += "บ้านเลขที่ " + this.items.address.house_no;
      // }
      // if (
      //   this.items.address.moo_no !== "" &&
      //   this.items.address.moo_no !== undefined
      // ) {
      //   text_address += " หมู่ที่ " + this.items.address.moo_no;
      // }

      // if (
      //   this.items.address.soi !== "" &&
      //   this.items.address.soi !== undefined
      // ) {
      //   text_address += " ถนน/ซอย " + this.items.address.soi;
      // }

      if (
        this.items.address.tambon !== "" &&
        this.items.address.tambon !== undefined
      ) {
        text_address += " ตำบล " + this.items.address.tambon;
      }

      if (
        this.items.address.amphur !== "" &&
        this.items.address.amphur !== undefined
      ) {
        text_address += " อำเภอ " + this.items.address.amphur;
      }

      if (
        this.items.address.province !== "" &&
        this.items.address.province !== undefined
      ) {
        text_address += " จังหวัด " + this.items.address.province;
      }

      // if (
      //   this.items.address.zipcode !== "" &&
      //   this.items.address.zipcode !== undefined
      // ) {
      //   text_address += " รหัสไปรษณีย์ " + this.items.address.zipcode;
      // }

      if (text_address == "") {
        this.getLocation(text_address);
        return "";
      } else {
        this.getLocation(text_address);
        this.items.location_address = text_address;
        return this.items.location_address;
      }
    },
    async getLocation(address) {
      // console.log("addres", address);
      try {
        const addressList = [
          address,
          this.items.address.tambon +
            " " +
            this.items.address.amphur +
            " " +
            this.items.address.province,
          this.items.address.amphur + " " + this.items.address.province,
          this.items.address.tambon + " " + this.items.address.province,
          this.items.address.province,
        ];

        for (const address of addressList) {
          const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            address
          )}&format=json`;

          const response = await fetch(url);
          const data = await response.json();

          if (data.length > 0) {
            const { lat, lon } = data[0];
            // console.log("Latitude:", lat);
            // console.log("Longitude:", lon);
            this.latitude = lat;
            this.longitude = lon;
            this.items.address.lat = lat;
            this.items.address.lng = lon;
            this.lat = lat;
            this.lng = lon;
            return;
          } else {
            console.log(`ไม่พบข้อมูลที่อยู่สำหรับ ${address}`);
          }
        }
      } catch (error) {
        console.error();
      }
    },

    // setPlace(place) {
    //   this.search = place.formatted_address;
    //   this.currentPlace = place;
    //   this.latitude = this.currentPlace.geometry.location.lat();
    //   this.longitude = this.currentPlace.geometry.location.lng();
    //   this.lat = this.currentPlace.geometry.location.lat();
    //   this.lng = this.currentPlace.geometry.location.lng();
    //   this.items.address.lat = this.currentPlace.geometry.location.lat();
    //   this.items.address.lng = this.currentPlace.geometry.location.lng();
    // },
    checkGPS() {
      let lat = Number(this.items.address.lat);
      let lng = Number(this.items.address.lng);
      this.items.address.lat = lat === 0 ? "" : lat;
      this.items.address.lng = lng === 0 ? "" : lng;
      // navigator.geolocation.getCurrentPosition(
      //   (position) => {
      //     const { coords: { latitude: lat, longitude: lng } = {} } = position;
      //     this.latitude = lat;
      //     this.longitude = lng;
      //     this.items.address.lat = lat;
      //     this.items.address.lng = lng;
      //     this.lat = lat;
      //     this.lng = lng;
      //   },
      //   (error) => {
      //     console.log(error);
      //     this.snackbar = true;
      //   }
      // );
    },
    async getProvince() {
      try {
        // this.items.address.zipcode = "";
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/province`)
          .then((res) => {
            if (res.status == 200) {
              this.set_province = res.data.data;
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${this.items.address.province}`
          )
          .then((res) => {
            // console.log("amphoe", res);
            if (res.status == 200) {
              this.set_amphoe = res.data.data;

              if (from == "template") {
                this.items.address.amphur = "";
                this.items.address.tambon = "";
              } else if (from == "api") {
                if (this.items.address.amphur) {
                  this.getTambon("api");
                } else {
                  this.items.address.tambon = "";
                }
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${this.items.address.province}/${this.items.address.amphur}`
          )
          .then(async (res) => {
            // console.log("tambon", res);
            if (res.status == 200) {
              if (from == "template") {
                this.set_tambon = res.data.data;
              } else if (from == "api") {
                this.set_tambon = res.data.data;
                await this.getPostal(this.items.address.tambon);
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    getPostal(e) {
      // console.log("this.set_tambon", this.set_tambon);
      var postal = this.set_tambon.find((ele) => {
        return ele.tambon === e;
      });

      if (postal !== undefined) {
        this.items.address.zipcode = postal.zipcode;
      } else {
        this.items.address.zipcode = "";
      }
    },
    async ConfirmedData() {
      if (!this.$refs.data_info.validate()) {
        await this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      } else {
        try {
          var body = {
            account_title_th: this.items.account_title_th,
            account_title_eng: this.items.account_title_eng,
            first_name_eng: this.items.first_name_eng,
            first_name_th: this.items.first_name_th,
            last_name_eng: this.items.last_name_eng,
            last_name_th: this.items.last_name_th,
            mobile: this.items.mobile,
            email: this.items.email,
            birth_date: this.items.birth_date,
            blood: this.items.blood,
            congenitalDisease: this.items.congenitalDisease,
            allergyDrug: this.items.allergyDrug,
            allergyDrugDetail: this.items.allergyDrugDetail,
            HN: this.items.HN,
            company: this.items.company,
            department: this.items.department,
            position: this.items.position,
            employee_id: this.items.employee_id,
          };

          await this.axios
            .put(
              `${process.env.VUE_APP_BACKEND_URL}/v1/patients/${this.items._id}`,
              body
            )
            .then(async (res) => {
              // console.log("res", res);
              if (res.data.code == 200 && res.data.result == "success") {
                await this.$swal({
                  icon: "success",
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>แก้ไขข้อมูลส่วนตัวสำเร็จ</span>",
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#00A99D",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  this.closePage();
                });
              } else {
                this.$swal({
                  icon: "error",
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>แก้ไขข้อมูลส่วนตัวไม่สำเร็จ</span>",
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#3085d6",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  this.closePage();
                });
              }
            });
        } catch (e) {
          console.log("error");
          this.$swal({
            icon: "error",
            title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
            confirmButtonText: "ปิด",
            confirmButtonColor: "#3085d6",
            showConfirmButton: false,
          }).then(() => {
            this.closePage();
          });
        }
      }
    },
    ConfirmedAddress(value) {
      // console.log(value);
      if (!this.$refs.add_info.validate()) {
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      } else {
        try {
          var address_id = value.address.id;
          var one_id = value.one_id;
          var cid = functioncryto.encrypt(value.id_card_num);
          var body = {
            houseNo: this.items.address.house_no,
            moo: this.items.address.moo_no,
            soi: this.items.address.soi,
            amphur: this.items.address.amphur,
            tambon: this.items.address.tambon,
            province: this.items.address.province,
            zipcode: this.items.address.zipcode,
            landmark: this.items.address.landmark,
            lat: this.items.address.lat,
            lng: this.items.address.lng,
            default_address: this.items.address.default,
          };
          // console.log("address_id", address_id);
          // console.log("body", body);

          const params = new URLSearchParams();
          params.append("biz_id", sessionStorage.biz_id);
          params.append("one_id", one_id);
          params.append("cid", cid);
          params.append("address_id", address_id || "");
          params.append("official", true);

          this.axios
            .post(
              `${process.env.VUE_APP_BACKEND_URL}/v1/patients/updatePatient_address?${params}`,
              body
            )
            .then(async (res) => {
              console.log("res", res);
              if (res.data.code == 200 && res.data.result == "success") {
                this.$swal({
                  icon: "success",
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>แก้ไขข้อมูลที่อยู่สำเร็จ</span>",
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#00A99D",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  this.closePage();
                });
              } else {
                this.$swal({
                  icon: "error",
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>แก้ไขข้อมูลที่อยู่ไม่สำเร็จ</span>",
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#3085d6",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  this.closePage();
                });
              }
            });
        } catch (e) {
          console.log("error", e);
          this.$swal({
            icon: "error",
            title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
            confirmButtonText: "ปิด",
            confirmButtonColor: "#3085d6",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.closePage();
          });
        }
      }
    },
    displayIdCard(idcard) {
      if (idcard === "" || idcard === undefined) return "หมายเลขบัตรประชาชน";
      if (idcard === "PASSPORT") return "PASSPORT";
      return "หมายเลขบัตรประชาชน";
    },
    calculateAge_menu(date) {
      if (date) {
        // console.log("date", date);
        this.items.birth_date = JSON.parse(JSON.stringify(date));
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.items.age = y.toString();
        this.menubirth_date = false;
      }
    },
    calculateAge(date) {
      if (date) {
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.items.age = y.toString();
      }
    },
    calculateAge_title(date) {
      if (date) {
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.item_original.age = y.toString();
      }
    },
    cancel_birth() {
      this.menubirth_date = false;
      this.items.age = "";
    },
    genderChange() {
      if (this.items.gender === "ชาย") {
        this.titleItems = ["เด็กชาย", "นาย"];
        if (!this.titleItems.includes(this.items.account_title_th)) {
          this.items.account_title_th = "เด็กชาย";
          this.items.account_title_eng = "Mr";
        }
      } else if (this.items.gender === "หญิง") {
        this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
        if (!this.titleItems.includes(this.items.account_title_th)) {
          this.items.account_title_th = "เด็กหญิง";
          this.items.account_title_eng = "Miss";
        }
      }
    },

    titleChange() {
      if (
        this.items.account_title_th === "นาย" ||
        this.items.account_title_th === "เด็กชาย"
      ) {
        this.items.gender = "ชาย";
        this.titleItems = ["เด็กชาย", "นาย"];
      }
      if (
        this.items.account_title_th === "นาง" ||
        this.items.account_title_th === "นางสาว" ||
        this.items.account_title_th === "เด็กหญิง"
      ) {
        this.items.gender = "หญิง";
        this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
      }
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "";
      }
    },
    formatDate(data) {
      if (!data) {
        return null;
      }

      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    ageCalcilar(birth, age_user) {
      if (birth != "" && birth != null) {
        const today = new Date();
        const birthDate = new Date(birth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        return age;
      } else {
        if (age_user) {
          return age_user;
        } else {
          return "-";
        }
      }
    },
  },
  mounted() {
    // console.log(this.e1);
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
  background: #ffffff !important;
}

.gmap-auto:focus {
  outline: none !important;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}

.topright {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 18px;
}
.bottomright {
  display: flex !important;
  justify-content: end !important;
  align-items: end !important;
}

::v-deep .disable-textfield > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .theme--light.v-input--is-disabled input {
  color: #333333 !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #333333 !important;
}
.custom-text {
  font-size: 18px;
  color: black;
}
</style>
